// Bilingual (English + Hindi) toggle. Persists in localStorage.
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "@/data/translations";

const LangCtx = createContext({ lang: "en", setLang: () => {}, t: (k, f) => f || k });

export const LanguageProvider = ({ children }) => {
    const [lang, setLangState] = useState(() => localStorage.getItem("vv_lang") || "en");

    useEffect(() => {
        localStorage.setItem("vv_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const setLang = useCallback((l) => setLangState(l === "hi" ? "hi" : "en"), []);

    const t = useCallback(
        (key, fallback) => {
            const dict = TRANSLATIONS[lang] || {};
            if (key in dict) return dict[key];
            // fall back to English copy, then to provided fallback or the key itself
            const en = TRANSLATIONS.en || {};
            if (key in en) return en[key];
            return fallback ?? key;
        },
        [lang]
    );

    const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

    return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
